import React, { useState, useEffect } from 'react'
import './department.css'
import { Link } from 'react-router-dom'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import profile from '../../../assets/profile.png'
import { useDispatch, useSelector } from 'react-redux'
import {handleOpenModal, handleCloseModal} from '../../../state/modalSlice'
import {handleDepartment} from '../../../state/deptSlice'
import {handleUsers} from '../../../state/userSlice'
import {getAllAcounts} from '../../../api'
import {addDepartment, fetchDepartment} from '../../../api/deptApi'
import Loader from '../../../components/loader/Loader'
import ActionCell from '../../../components/actionCell/ActionCell'
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);



const columns = [
    {
        field: 'id',
        headerName: 'ID',
        width: 90,
    },
    {
        field: 'name',
        headerName: 'Department Name',
        width: 200,
    },
    {
        field: 'head',
        headerName: 'Head of Dept.',
        width: 200,
    },
    {
        field: 'totalUsers',
        headerName: 'Total Staffs',
        width: 150,
    },
    {
        field: 'action',
        headerName: 'Action',
        width: 100,
        renderCell: (param) => <ActionCell param={param} />
    },
];


const AddDepartment = ({closeModal, users, user, modal, handleGetDept}) => {
    const [isLoading, setIsLoading] = useState(false)
    const {
        register,
        handleSubmit,
        formState:{errors},
        reset
    } = useForm({
        mode: 'onChange',
        defaultValues: modal?.data ? {...modal?.data} : ''
    })

    const handleSubmitDept = async (data) =>{
        setIsLoading(true)
        try{
            const res = await addDepartment(user?.token, data)
            if(res?.data){
                MySwal.fire({
                    icon: 'success',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                handleGetDept()
                closeModal()
                reset()
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
            setIsLoading(false)
        }catch(error){
            console.log(error)
            setIsLoading(false)
            MySwal.fire({
                icon: 'error',
                title: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }

    return (
        <div className="modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
                <div className="modal-heading">
                    <h4 className="modal-title">Add Department</h4>
                    <button type='button' onClick={closeModal}
                    className="modal-btn">
                        <i class='bx bx-x'></i>
                    </button>
                </div>
                <form className="modal-form" onSubmit={handleSubmit(handleSubmitDept)}>
                    <div className="modal-field">
                        <label htmlFor="name" className='modal-label'>
                            Department Name <span>*</span> (Note: Do not include 'Department')
                        </label>
                        <input type="text" name='name' className="modal-input" 
                        {...register('name',{required: 'This field is required!'})}/>
                        {errors.name && <span className="modal-error">
                            {errors?.name?.message}
                        </span>}
                    </div>
                    <div className="modal-field">
                        <label htmlFor="headOfDept" className='modal-label'>
                            Head of Department <span>*</span>
                        </label>
                        <select name="head" className="modal-input"
                        {...register('head',{required: 'This field is required!'})}>
                            <option value="" disabled>Select a staff</option>
                            {
                                users?.map((item)=>(
                                    <option value={item?._id}>
                                        {item?.firstName + ' ' + item?.lastName}
                                    </option>
                                ))
                            }
                            {errors.head && <span className="modal-error">
                                {errors?.head?.message}
                            </span>}
                        </select>
                    </div>
                    <div className="modal-field">
                        {
                            isLoading ? <Loader/> : <button type='submit'
                            className='modal-button button'>
                                Add Department
                            </button>
                        }
                    </div>
                </form>

            </div>
        </div>
    )
}


const Department = () => {
    const {user, users} = useSelector((state)=>state.user)
    const {modal} = useSelector((state)=>state.modal)
    const {department} = useSelector((state)=>state.department)
    const [value, setValue] = useState('')
    const dispatch = useDispatch()


    const openModal = () => {
        dispatch(handleOpenModal())
    }

    const closeModal = () => {
        dispatch(handleCloseModal())
    }

    const handleGetUsers = async ()=>{
        try{
            const res = await getAllAcounts(user?.token)
            dispatch(handleUsers(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    const handleGetDept = async () =>{
        try{
            const res = await fetchDepartment(user?.token)
            dispatch(handleDepartment(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    const filterItems = department?.filter((item)=>{
        return item?.name?.toLowerCase()?.includes(value.toLowerCase())
        || item?.head?.toLowerCase()?.includes(value.toLowerCase())
    })

    useEffect(()=>{
        handleGetDept()
        handleGetUsers()
    },[])


  return (
    <section className='department'>
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">All Department | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        Department <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    All Department
                </p>
            </div>
            <button 
            onClick={openModal}
            className="heading__box-btn button">
                Add Department
            </button>
        </div>

        <div className="department__container">
            <div className="department__items">
                <div className="department__search">
                    <h4 className="department__search-title">Departments</h4>
                    <div className="department__search-box">
                        <span className="department__search-span">Search:</span>
                        <input type="text" placeholder="Name or email..."
                        value={value} onChange={(e)=>setValue(e.target.value)}
                        className='department__search-input'/>
                    </div>
                </div>

                <div className="department__table">
                    <DataGrid
                        // getRowId={(rows => rows._id)}
                        rows={filterItems?.map((item, i)=>({
                            id: i + 1,
                            ...item
                        })) ?? []}
                        columns={columns}
                        initialState={{
                        pagination: {
                            paginationModel: {
                            pageSize: 5,
                            },
                        },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection
                        disableRowSelectionOnClick
                        getRowHeight={() => 'auto'} 
                        sx={{
                            margin: 'auto',                        
                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                                py: 0.5,
                            },
                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                                py: '5px',
                            },
                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                                py: '10px',
                            },
                        }}
                        experimentalFeatures={{ lazyLoading: true }}
                    />
                </div>
            </div>
        </div>
        {modal?.show && <AddDepartment 
        modal={modal}
        users={users}
        user={user}
        closeModal={closeModal}
        handleGetDept={handleGetDept}/>}
    </section>
  )
}

export default Department